module.exports = __webpack_public_path__ + "img/service-vps.0327dc7.svg";